import request from './request'

/**
 * 在线支付下单（蓝新金流 MPG）。
 *
 * 注意：本函数只到「下单」为止 —— 后端返回 { gateway, form }，
 * 前端必须用**HTML Form Post 真跳转**到 gateway（见 Recharge.vue 的 submitToGateway）。
 * 不要用 axios 去 post 蓝新：官方明确禁止 iframe / 代理 / 服务端幕后 HttpPost，
 * 违反会得到 MPG02005「驗證資料錯誤（來源不合法）」。余额也只在蓝新回调后入账。
 *
 * 参数：amount（新台币整数）、pay_method（单选：CREDIT / APPLEPAY / ANDROIDPAY /
 *       VACC / CVS / WEBATM / ESUNWALLET）
 *       ★Google Pay 的开关参数名是 ANDROIDPAY（GOOGLEPAY 只出现在回调里），别写反。
 */
export function createRecharge(payload) {
  return request.post('/user/recharge', payload)
}

/** 查询某笔充值订单状态（ReturnURL 跳回后轮询用：NotifyURL 可能比浏览器跳回晚到） */
export function fetchRechargeStatus(orderNo) {
  return request.get('/user/newebpayStatus', { params: { order_no: orderNo } })
}

/** 积分余额+规则 */
export function fetchBalance() {
  return request.get('/user/balance')
}

/** 预估本次生成消耗（模型由后端按参数选，前端只展示积分） */
export function estimateImage(params = {}) {
  return request.post('/user/estimateImage', null, { params })
}

/** 积分明细（消费/充值） */
export function fetchTransactions(params = {}) {
  return request.get('/user/transactions', { params })
}

/** 充值记录（后端只返回**已到账**的 paid 单；未付款的 pending 单不出现在用户端） */
export function fetchRecharges(params = {}) {
  return request.get('/user/recharges', { params })
}

/** 公开积分规则 */
export function fetchRules() {
  return request.get('/user/rules')
}
